import type { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import SunshineIconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

import locales from './locales';

interface Props {
  receipt: ReceiptType;
  onRemove: (receipt: ReceiptType) => void;
}

const ReceiptUploadItem: FC<Props> = ({ onRemove, receipt }) => {
  return (
    <SunshineCard alignItems="center">
      <SunshineCard.Slot name="aside">
        <SquircleIcon name="file" />
      </SunshineCard.Slot>
      <SunshineCard.Content>
        <SunshineCard.Title>{locales.receipt}</SunshineCard.Title>
      </SunshineCard.Content>
      <SunshineCard.Slot name="action">
        <HStack spacing="space-16">
          <SunshineIconButton
            aria-label="Open"
            as="a"
            href={receipt.url}
            icon="eye-open"
            rel="noopener noreferrer"
            target="_blank"
            variant="secondary"
          />
          <SunshineIconButton
            aria-label="Remove"
            icon="trash"
            onClick={() => onRemove(receipt)}
            variant="secondary"
          />
        </HStack>
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default ReceiptUploadItem;
